<template>
  <el-row :gutter="24" :class="`ta-c ${className}`">
    <el-col v-if="isSlot" :span="2">
      <slot />
    </el-col>
    <el-col v-for="title in titles" :key="title.name" :span="title.span">
      {{ title.name }}
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'ListTitles',
  props: {
    titles: {
      type: Array,
      default: () => [],
    },
    className: {
      type: String,
      default: '',
    },
    isSlot: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
